import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const plan = {
  domain: 'downtownautopro.com',
  generatedAt: '2026-05-14T14:00:00Z',
  summary: {
    total_keywords: 25,
    page1_count: 6,
    page2_count: 9,
    not_ranking: 10,
    opportunity_count: 8,
    seo_score: 61
  },
  actions: [
    { priority: 'high', category: 'On-Page SEO', action: 'Fix missing or poorly optimized title tags and meta descriptions across key service pages including Oil Change, Brake Repair, and Transmission Service.', impact: 'Direct ranking improvement within 30-60 days.' },
    { priority: 'high', category: 'Keyword Gaps', action: 'Create or optimize pages targeting high-value missing keywords including: "auto repair near me", "brake service downtown", "engine diagnostic cost".', impact: 'Potential to capture 8,400 additional monthly searches.' },
    { priority: 'high', category: 'Technical SEO', action: 'Resolve page speed issues on mobile (current load time 6.2s). Compress images and enable browser caching.', impact: 'Improved crawlability, indexing, and user experience.' },
    { priority: 'medium', category: 'Quick Wins', action: 'Push 9 page-2 keywords to page 1 with targeted content improvements and internal linking. Top targets: "transmission repair", "oil change coupons", "wheel alignment cost".', impact: 'Page 1 rankings typically receive 10x more clicks than page 2.' },
    { priority: 'medium', category: 'Content', action: 'Expand thin service pages with more comprehensive content, FAQs, and pricing information. Average word count is 180 words vs recommended 600+.', impact: 'Better topical authority and longer dwell time.' },
    { priority: 'medium', category: 'Authority Building', action: 'Build quality backlinks through local citations, BBB listing, and outreach to local news and community sites.', impact: 'Higher domain authority improves rankings across all keywords.' },
  ],
  rankings: [
    { keyword: 'downtown auto repair', position: 3 },
    { keyword: 'auto repair shop chicago', position: 5 },
    { keyword: 'car repair near loop', position: 7 },
    { keyword: 'oil change downtown chicago', position: 8 },
    { keyword: 'mechanic near michigan ave', position: 9 },
    { keyword: 'brake repair chicago', position: 10 },
    { keyword: 'transmission repair downtown', position: 14 },
    { keyword: 'oil change coupons chicago', position: 15 },
    { keyword: 'wheel alignment cost chicago', position: 16 },
    { keyword: 'engine diagnostic chicago', position: 17 },
    { keyword: 'car ac repair chicago', position: 18 },
    { keyword: 'tire rotation near me chicago', position: 19 },
    { keyword: 'auto repair estimate online', position: 28 },
    { keyword: 'best mechanic chicago', position: 31 },
    { keyword: 'check engine light chicago', position: 34 },
  ],
  opportunities: [
    { keyword: 'auto repair near me', search_volume: 3600, found_on_competitor: 'chicagomobilemechanic.com' },
    { keyword: 'brake service near me', search_volume: 1900, found_on_competitor: 'chicagomobilemechanic.com' },
    { keyword: 'engine diagnostic cost', search_volume: 1300, found_on_competitor: 'northsideauto.com' },
    { keyword: 'car tune up near me', search_volume: 1000, found_on_competitor: 'northsideauto.com' },
    { keyword: 'auto repair coupons chicago', search_volume: 720, found_on_competitor: 'chicagomobilemechanic.com' },
    { keyword: 'same day auto repair', search_volume: 590, found_on_competitor: 'loopautocenter.com' },
    { keyword: 'car inspection chicago', search_volume: 480, found_on_competitor: 'loopautocenter.com' },
    { keyword: 'radiator repair chicago', search_volume: 320, found_on_competitor: 'northsideauto.com' },
  ],
  audit: {
    overall: 61,
    categories: { technical: 58, onpage: 52, content: 64, authority: 70 },
    topIssues: [
      'Mobile page speed: 6.2s load time (target under 3s)',
      '14 pages missing meta descriptions',
      '8 images missing alt text',
      'No schema markup on service pages',
      'Sitemap not submitted to Google Search Console',
    ]
  }
};

export default function SampleActionPlanPage() {
  const [section, setSection] = useState('actions');

  const ScoreBar = ({ label, score, color }) => (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
        <span style={{ color: '#555' }}>{label}</span>
        <span style={{ fontWeight: 700 }}>{score}/100</span>
      </div>
      <div style={{ height: 6, background: '#f0f0f0', borderRadius: 3 }}>
        <div style={{ height: 6, width: `${score}%`, background: color, borderRadius: 3 }} />
      </div>
    </div>
  );

  return (
    <div style={{ fontFamily: 'IBM Plex Sans, sans-serif', color: '#1a1a1a', minHeight: '100vh', background: '#f5f5f5' }}>

      {/* Nav */}
      <nav style={{ background: '#1a1a1a', padding: '16px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to="/" style={{ fontSize: 13, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', textDecoration: 'none', color: '#fff' }}>
          Clarity<span style={{ fontWeight: 300, opacity: 0.4 }}> Reporting</span>
        </Link>
        <Link to="/register" style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none', color: '#fff', background: '#FFE066', color: '#1a1a1a', padding: '8px 20px' }}>
          Start Free Trial
        </Link>
      </nav>

      {/* Header banner */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e0e0e0', padding: '24px 40px' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: '#CC0000', marginBottom: 6 }}>Sample SEO Action Plan</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 12 }}>
            <div>
              <h1 style={{ fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Downtown Auto Pro &mdash; SEO Action Plan</h1>
              <div style={{ fontSize: 13, color: '#888' }}>downtownautopro.com &nbsp;&bull;&nbsp; Generated May 14, 2026 &nbsp;&bull;&nbsp; This is sample data for demonstration purposes</div>
            </div>
            <div style={{ display: 'flex', gap: 24 }}>
              {[
                { label: 'Keywords Tracked', value: plan.summary.total_keywords },
                { label: 'Page 1 Rankings', value: plan.summary.page1_count },
                { label: 'Opportunities', value: plan.summary.opportunity_count },
                { label: 'SEO Score', value: `${plan.summary.seo_score}/100` },
              ].map(s => (
                <div key={s.label} style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 28, fontWeight: 700, fontFamily: 'monospace', lineHeight: 1 }}>{s.value}</div>
                  <div style={{ fontSize: 11, color: '#888', marginTop: 4, letterSpacing: 0.5 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1000, margin: '0 auto', padding: '24px 40px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 24 }}>

          {/* Left column */}
          <div>
            {/* Tab nav */}
            <div style={{ display: 'flex', gap: 2, marginBottom: 16 }}>
              {[['actions','Recommended Actions'],['keywords','Keyword Rankings'],['opportunities','Growth Opportunities']].map(([key, label]) => (
                <button key={key} onClick={() => setSection(key)} style={{ padding: '8px 16px', fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', border: 'none', cursor: 'pointer', background: section === key ? '#1a1a1a' : '#e8e8e8', color: section === key ? '#fff' : '#555' }}>
                  {label}
                </button>
              ))}
            </div>

            {/* Actions */}
            {section === 'actions' && (
              <div>
                {plan.actions.map((action, i) => (
                  <div key={i} style={{ background: '#fff', marginBottom: 8, padding: '16px 18px', borderLeft: `4px solid ${action.priority === 'high' ? '#CC0000' : '#e0a800'}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                      <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#555' }}>{action.category}</span>
                      <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', color: action.priority === 'high' ? '#CC0000' : '#e0a800', background: action.priority === 'high' ? '#fff0f0' : '#fffbe6', padding: '2px 8px' }}>{action.priority} priority</span>
                    </div>
                    <div style={{ fontSize: 14, color: '#333', marginBottom: 6, lineHeight: 1.6 }}>{action.action}</div>
                    <div style={{ fontSize: 12, color: '#888', fontStyle: 'italic' }}>Impact: {action.impact}</div>
                  </div>
                ))}
              </div>
            )}

            {/* Keywords */}
            {section === 'keywords' && (
              <div style={{ background: '#fff' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ borderBottom: '2px solid #e0e0e0' }}>
                      <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#888' }}>Keyword</th>
                      <th style={{ textAlign: 'center', padding: '10px 16px', fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#888' }}>Rank</th>
                      <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#888' }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {plan.rankings.map((kw, i) => (
                      <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <td style={{ padding: '10px 16px', fontFamily: 'monospace' }}>{kw.keyword}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                          <span style={{ display: 'inline-block', padding: '2px 8px', fontSize: 12, fontWeight: 700, background: kw.position <= 10 ? '#e6f4ea' : '#fafafa', color: kw.position <= 10 ? '#1a7a1a' : '#555', border: `1px solid ${kw.position <= 10 ? '#a8d5b5' : '#e0e0e0'}` }}>
                            #{kw.position}
                          </span>
                        </td>
                        <td style={{ padding: '10px 16px', fontSize: 12, color: kw.position <= 10 ? '#1a7a1a' : kw.position <= 20 ? '#e0a800' : '#888' }}>
                          {kw.position <= 10 ? 'Page 1' : kw.position <= 20 ? 'Page 2' : 'Page 3+'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Opportunities */}
            {section === 'opportunities' && (
              <div style={{ background: '#fff' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ borderBottom: '2px solid #e0e0e0' }}>
                      <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#888' }}>Missing Keyword</th>
                      <th style={{ textAlign: 'right', padding: '10px 16px', fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#888' }}>Searches/mo</th>
                      <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#888' }}>Competitor Ranking</th>
                    </tr>
                  </thead>
                  <tbody>
                    {plan.opportunities.map((op, i) => (
                      <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <td style={{ padding: '10px 16px', fontFamily: 'monospace' }}>{op.keyword}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700 }}>{op.search_volume.toLocaleString()}</td>
                        <td style={{ padding: '10px 16px', fontSize: 12, color: '#888' }}>{op.found_on_competitor}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ padding: '12px 16px', background: '#fffbe6', borderTop: '1px solid #ffe58f', fontSize: 13 }}>
                  <strong>Total missed traffic potential:</strong> {plan.opportunities.reduce((s, o) => s + o.search_volume, 0).toLocaleString()} searches/month from keywords your competitors rank for that you do not.
                </div>
              </div>
            )}
          </div>

          {/* Right column */}
          <div>
            {/* SEO Health */}
            <div style={{ background: '#fff', padding: '20px', marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', color: '#888', marginBottom: 16 }}>SEO Health Score</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
                <div style={{ width: 70, height: 70, borderRadius: '50%', background: `conic-gradient(#e0a800 ${plan.audit.overall * 3.6}deg, #f0f0f0 0)`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ width: 54, height: 54, borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'monospace', fontWeight: 700, fontSize: 18 }}>{plan.audit.overall}</div>
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#e0a800' }}>Needs Work</div>
                  <div style={{ fontSize: 12, color: '#888' }}>Score out of 100</div>
                </div>
              </div>
              <ScoreBar label="Technical" score={plan.audit.categories.technical} color="#4a90e2" />
              <ScoreBar label="On-Page" score={plan.audit.categories.onpage} color="#CC0000" />
              <ScoreBar label="Content" score={plan.audit.categories.content} color="#e0a800" />
              <ScoreBar label="Authority" score={plan.audit.categories.authority} color="#1a7a1a" />
            </div>

            {/* Top Issues */}
            <div style={{ background: '#fff', padding: '20px', marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', color: '#888', marginBottom: 12 }}>Top Issues Found</div>
              {plan.audit.topIssues.map((issue, i) => (
                <div key={i} style={{ display: 'flex', gap: 10, padding: '7px 0', borderBottom: '1px solid #f5f5f5', fontSize: 12, color: '#444' }}>
                  <span style={{ color: '#CC0000', fontWeight: 700, flexShrink: 0 }}>&#9679;</span> {issue}
                </div>
              ))}
            </div>

            {/* CTA */}
            <div style={{ background: '#1a1a1a', padding: '24px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: 'rgba(255,255,255,0.5)', marginBottom: 10 }}>Ready for your site?</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 8, lineHeight: 1.4 }}>Get a real action plan generated from your live data</div>
              <Link to="/register" style={{ display: 'block', marginTop: 16, padding: '12px', background: '#FFE066', color: '#1a1a1a', fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none', textAlign: 'center' }}>
                Start Free Trial
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
